const loadImage = (ldSrc, hdSrc, imgId) => {
    let hdLoaded = false;

    const onload = (src, isHighDef) => {
        if (hdLoaded) {
            return;  // Skip if HD image is already displayed.
        }

        // Render the pre-loaded image on the DOM.
        const div = document.querySelector(`div#${imgId}`);
        div.classList.add("fade-in");
        div.style.backgroundImage = `url(${src})`;

        if (isHighDef) {
            // Set this flag in case the LD image finishes loading after the HD image. This
            // will prevent it from "overwriting" the HD image.
            hdLoaded = true;
        }
    };

    // Prefetch low definition image.
    const ldImage = new Image();
    ldImage.src = ldSrc;
    ldImage.fetchPriority = 'high';
    ldImage.onload = () => onload(ldSrc, false);

    // Prefetch high definition image.
    const hdImage = new Image();
    hdImage.src = hdSrc;
    hdImage.fetchPriority = 'high';
    hdImage.onload = () => onload(hdSrc, true);
};

// Initialize a media query for mobile width.
const mobileMediaQuery = window.matchMedia('(max-width: 600px)');

// Maintain a "store" of image sources for the media query listener to reference.
const imageSources = [];

// Used by Liquid Sections to add sources to the "store" and load its images.
const enqueueImageSources = (mobileLdSrc, mobileHdSrc, mobileImgId, desktopLdSrc, desktopHdSrc, desktopImgId) => {
    // Add the img src metadata to the "store".
    imageSources.push({mobileLdSrc, mobileHdSrc, mobileImgId, desktopLdSrc, desktopHdSrc, desktopImgId});

    // Actually load the image when the Liquid Section first requests it.
    loadResponsiveImages(
        mobileMediaQuery,
        mobileLdSrc, mobileHdSrc, mobileImgId,
        desktopLdSrc, desktopHdSrc, desktopImgId,
    );
};

const loadResponsiveImages = (
    mobileMediaQuery,
    mobileLdSrc, mobileHdSrc, mobileImgId,
    desktopLdSrc, desktopHdSrc, desktopImgId,
) => {
    if (mobileMediaQuery.matches) {
        loadImage(mobileLdSrc, mobileHdSrc, mobileImgId);
    } else {
        loadImage(desktopLdSrc, desktopHdSrc, desktopImgId);
    }
};

// Initialize the media query listener, which iterates through the "store" of img srcs on each resize.
mobileMediaQuery.addEventListener("change", (mediaQueryList) => {
    imageSources.forEach(({mobileLdSrc, mobileHdSrc, mobileImgId, desktopLdSrc, desktopHdSrc, desktopImgId}) => {
        loadResponsiveImages(
            mediaQueryList,
            mobileLdSrc, mobileHdSrc, mobileImgId,
            desktopLdSrc, desktopHdSrc, desktopImgId
        );
    })
});
